import { ValidationEnum } from '../features/validator/ValidatorField';
export const accountFieldVerify = (func) => {
    return (val, prev, init) => {
        const valid = func(val) ? null : false;
        if (init === ValidationEnum.REFRESH)
            return valid;
        if (init === ValidationEnum.BLUR)
            return val !== '' ? valid : null;
        if (init === ValidationEnum.CHANGE)
            return prev === false ? valid : null;
        return null;
    };
};
